import { render, staticRenderFns } from "./PictureUpload.vue?vue&type=template&id=0578c7e2&scoped=true"
import script from "./PictureUpload.vue?vue&type=script&lang=js"
export * from "./PictureUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0578c7e2",
  null
  
)

export default component.exports